import ToggleView from './ToggleView';

export default ToggleView;
